export const SocialData=[
    {
        platform:"Linkedin",
        icon: require("../../assets/icons/linkedin.png"),
        link:"https://www.linkedin.com/in/christophernez",
    },
    {
        platform:"Github",
        icon: require("../../assets/icons/github.png"),
        link:"https://github.com/krystopherNez",
    },
    {
        platform:"Whatsapp",
        icon: require("../../assets/icons/whatsapp.png"),
        link:"https://wa.me/+2348061537193",
    },
    {
        platform:"Twitter",
        icon: require("../../assets/icons/twitter.png"),
        link: "https://twitter.com/krystopherNez",
    },
    {
        platform:"Facebook",
        icon: require("../../assets/icons/facebook.png"),
        link:"https://www.facebook.com/ceneze/",
    },
];